module.exports = __webpack_public_path__ + "img/auditDown.d533405e.png";